export { default } from './DetailsRequiredModal';
